import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@/config/client/i18n';
import { getLocales } from '@/modules/core/client/utils/locales';
import Board from './Board';
import FooterMenu from '@/modules/cms/client/components/FooterMenu.component';

export default function Footer() {
  const { t } = useTranslation('core');
  const locales = getLocales();
  const currentLanguage = (i18n.language || 'en').split('-')[0];

  const handleLanguageChange = code => {
    // Persist language choice in the same cookie i18next-browser-languagedetector uses
    const oneYearInSeconds = 60 * 60 * 24 * 365;
    document.cookie = `i18n=${code};path=/;max-age=${oneYearInSeconds}`;
    i18n.changeLanguage(code);
    window.location.reload();
  };

  return (
    <div>
      <Board
        className="board-primary board-inset home-footer"
        names="bokeh"
        ignoreBackgroundOnSmallScreen
      >
        <div className="container">
          <div className="row">
            <div className="col-sm-6 col-md-3">
              <h3 className="font-brand-light">{t('About HostFolk')}</h3>
              <p>
                {t(
                  `HostFolk is a homestay platform built around the idea that hospitality can be transformative. It connects international exchange students, independent travellers, and host families through meaningful Homestay experiences, fostering cultural exchange, friendship, and personal growth.`,
                )}
              </p>
              <p>
                <i className="icon-right"></i>
                <a
                  href="/foundation"
                  className="home-footer-more font-brand-semibold"
                >
                  {t('Learn more')}
                </a>
              </p>
            </div>
            {/* The link columns (Company / Explore / Customer Service) are
                managed from Admin → CMS → Footer menu. The original columns
                are passed as the fallback, shown until the CMS menu loads or
                if it is empty, so the footer is never blank. */}
            <FooterMenu
              columnClassName="col-sm-6 col-md-3"
              fallback={
                <>
                  <div className="col-sm-6 col-md-3">
                    <h3 className="font-brand-light">{t('Company')}</h3>
                    <ul className="list-unstyled home-footer-pages font-brand-light">
                      <li>
                        <a href="/foundation">{t('About HostFolk')}</a>
                      </li>
                      <li>
                        <a href="/rules">{t('Terms and Conditions')}</a>
                      </li>
                      <li>
                        <a href="/privacy">{t('Privacy Policy')}</a>
                      </li>
                      <li>
                        <a href="/volunteering">{t('Work with Us')}</a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-sm-6 col-md-3">
                    <h3 className="font-brand-light">{t('Explore')}</h3>
                    <ul className="list-unstyled home-footer-pages font-brand-light">
                      <li>
                        <a href="/signup">{t('Join')}</a>
                      </li>
                      <li>
                        <a href="/signin">{t('Login')}</a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-sm-6 col-md-3">
                    <h3 className="font-brand-light">
                      {t('Customer Service')}
                    </h3>
                    <ul className="list-unstyled home-footer-pages font-brand-light">
                      <li>
                        <a href="/faq">{t('FAQ')}</a>
                      </li>
                      <li>
                        <a href="/support">{t('Contact & support')}</a>
                      </li>
                    </ul>
                  </div>
                </>
              }
            />
          </div>

          <div className="row text-center">
            <hr className="hr-white hr-xs" />
            <small className="font-brand-light">
              <span className="boards-credits">
                {t('© 2025 All rights reserved by HostFolk')}
              </span>
            </small>
            <div
              className="home-footer-languages"
              style={{ marginTop: '10px' }}
            >
              {locales.map(locale => (
                <button
                  key={locale.code}
                  type="button"
                  className="btn btn-link btn-xs"
                  style={{
                    color:
                      locale.code === currentLanguage ? '#ffffff' : '#cfd8dc',
                    textDecoration:
                      locale.code === currentLanguage ? 'underline' : 'none',
                  }}
                  onClick={() => handleLanguageChange(locale.code)}
                >
                  {locale.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </Board>
    </div>
  );
}

Footer.propTypes = {};
